/**
 * @generated SignedSource<<b18880c95a88e91ee675a5ab3e7a2f6a>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37

import type { ConcreteRequest } from 'relay-runtime';
export type useDynamicSplitButtonLastModifiedDateQuery$variables = {
  contentId: string;
};
export type useDynamicSplitButtonLastModifiedDateQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly lastModifiedDate: string | null;
      };
    } | null> | null;
  } | null;
};
export type useDynamicSplitButtonLastModifiedDateQuery = {
  response: useDynamicSplitButtonLastModifiedDateQuery$data;
  variables: useDynamicSplitButtonLastModifiedDateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDynamicSplitButtonLastModifiedDateQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDynamicSplitButtonLastModifiedDateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
    "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
    "metadata": {},
    "name": "useDynamicSplitButtonLastModifiedDateQuery",
    "operationKind": "query",
    "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
  }
};
})();

(node as any).hash = "cb78a829ad38a06c36dc9615c22411b7";

export default node;
